import { FeatureFlagOverride } from 'shared/feature-flags/feature-flag-storage';

export interface ResolveFeatureFlagParams {
  /** Ручное значение из localStorage; `null`, если его нет. */
  override: FeatureFlagOverride | null;
  /** `created_at` пользователя как его отдаёт API — ISO-строка. */
  userCreatedAt: string | null | undefined;
  /** Дата отсечки флага из реестра. */
  since: string;
}

/**
 * Чистое разрешение флага: override сильнее даты, битая или отсутствующая дата — выключено.
 */
export const resolveFeatureFlag = ({ override, userCreatedAt, since }: ResolveFeatureFlagParams): boolean => {
  if (override) {
    return override === 'on';
  }

  if (!userCreatedAt) {
    return false;
  }

  const createdAt = Date.parse(userCreatedAt);
  const sinceAt = Date.parse(since);

  if (Number.isNaN(createdAt) || Number.isNaN(sinceAt)) {
    return false;
  }

  return createdAt >= sinceAt;
};
